import dayIcon from "../../../../assets/icons/day.webp";
import weekIcon from "../../../../assets/icons/week.webp";
import yearIcon from "../../../../assets/icons/year.webp";

export const getPeriodIcon = (period: string) => {
  switch (period.toLowerCase()) {
    case "day":
    case "היום":
      return dayIcon;
    case "week":
    case "השבוע":
      return weekIcon;
    case "month":
    case "החודש":
      return yearIcon; // Using year icon for month as no month icon available
    case "year":
    case "השנה":
      return yearIcon;
    default:
      return undefined;
  }
};

export const getPeriodAltText = (period: string) => {
  switch (period.toLowerCase()) {
    case "day":
    case "היום":
      return "Day icon";
    case "week":
    case "השבוע":
      return "Week icon";
    case "month":
    case "החודש":
      return "Month icon";
    case "year":
    case "השנה":
      return "Year icon";
    default:
      return "Period icon";
  }
};
